<template>
  <div id="paso1">
    <paso-actual />
    <div class="row mt-3">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <label>Apellido <i class="fas fa-asterisk"></i></label>
        <input type="text" v-model="apellido" class="form-control">
     </div>
     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
       <label>Nombres <i class="fas fa-asterisk"></i></label>
       <input type="text" v-model="nombre" class="form-control">
     </div>
   </div>

   <div class="row mt-3">
     <div class=" col-xs-12 col-sm-12 col-md-3 col-lg-3">
       <label>Documento <i class="fas fa-asterisk"></i></label>
       <input type="text" v-model="documento" class="form-control">
     </div>
     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
       <label style="display: block;">Fecha de nacimiento <i class="fas fa-asterisk"></i></label>
       <select class="custom-select c2" v-model="dd">
         <option v-for="dia in dias" :key="dia.key" :value="dia">{{ dia }}</option>
       </select>
       <span>/</span>
       <select class="custom-select mes" v-model="mm">
         <option value="0"></option>
         <option v-for="mes in meses" :key="mes.key" :value="mes | moment('MM')">{{ mes | moment('MMMM') }}</option>
       </select>
       <span>/</span>
       <select class="custom-select anio" v-model="aa">
         <option v-for="anio in anios" :key="anio.key" :value="anio">{{ anio }}</option>
       </select>
     </div>
     <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
       <label style="display: block;">Sexo <i class="fas fa-asterisk"></i></label>
       <select class="custom-select" v-model="sexo">
         <option v-for="s in sexos" :key="s.key" :value="s.id">{{ s.nombre }}</option>
       </select>
     </div>
   </div>

   <div class="row mt-3">
     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
       <label>Provincia <i class="fas fa-asterisk"></i></label>
       <select class="custom-select" v-model="provincia">
         <option value="0"></option>
         <option v-for="provincia in provincias" :key="provincia.key" :value="provincia">{{ provincia.nombre }}</option>
       </select>
     </div>
     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
       <label>Localidad <i class="fas fa-asterisk"></i></label>
       <select class="custom-select" v-model="localidad">
         <option value="0">-</option>
         <option v-for="localidad in localidades" :key="localidad.key" :value="localidad">{{ localidad.nombre }}</option>
         <option value="-1">Otra</option>
       </select>
       <input v-if="localidad==-1" type="text" v-model="otraLocalidad" class="form-control" />
     </div>
     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
       <label>Domicilio <i class="fas fa-asterisk"></i></label>
       <input type="text" v-model="domicilio" class="form-control">
     </div>
   </div>

   <div class="row mt-3">
     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
       <label>C&#243;nyugue</label>
       <input type="text" v-model="conyugue" class="form-control">
     </div>
   </div>

   <div class="row mt-3">
     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
       <label>Tel&#233;fono <i class="fas fa-asterisk"></i></label>
       <input type="text" v-model="telefono" class="form-control">
     </div>
     <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
       <label>Email <i class="fas fa-asterisk"></i></label>
       <input type="text" v-model="email" class="form-control">
     </div>
   </div>

   <div class="row mt-3">
     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
       <label>Foto <i class="fas fa-asterisk"></i></label>
       <input type="file" ref="file" class="form-control file" @change="changeListener" />
       <button class="btn btn-default btn-sm" @click="seleccionarArchivo">seleccionar archivo</button>
       <a href="javascript:void(null)" @click="borrarArchivo">
         borrar
       </a>
       {{ file.name }}
     </div>
   </div>

   <hr />

   <div class="row mt-2">
     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
       <button class="btn btn-success btn-sm" @click="confirmar">Continuar</button>
       <button class="btn btn-primary btn-sm cancelar ml-2">Cancelar</button>
     </div>
   </div>

  </div>
</template>

<script>
  import PasoActual from './PasoActual';
  import EventBus from '../EventBus';

  export default {
    data: () => ({
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      file: '',
      apellido: '',
      nombre: '',
      fechaNacimiento: '',
      sexo: '',
      dd: '',
      mm: '',
      aa: '',
      documento: '',
      localidad: '',
      provincia: '',
      domicilio: '',
      conyugue: '',
      provincias: '',
      localidades: '',
      otraLocalidad: '',
      telefono: '',
      email: '',
      dias: [],
      meses: [],
      anios: [],
      sexos: [{
        id: '-',
        nombre: '-'
      }, {
        id: 'F',
        nombre: 'Femenino'
      }, {
        id: 'M',
        nombre: 'Masculino'
      }]
    }),
    methods: {
      mostrarMensaje: function(mensaje) {
        EventBus.$emit('MOSTRAR_MENSAJE', mensaje);
      },
      // ...
      // Boton continuar.
      // ...
      confirmar: function() {
        if (this.apellido.trim() == "") {
          return this.mostrarMensaje('Ingrese el apellido!');
        }
        if (this.nombre.trim() == "") {
          return this.mostrarMensaje('Ingrese el nombre!');
        }
        if (this.documento.trim() == "") {
          return this.mostrarMensaje('Ingrese el documento!');
        }
        if (this.provincia == 0) {
          return this.mostrarMensaje('Ingrese la provincia!');
        }
        if (this.localidad == 0) {
          return this.mostrarMensaje('Ingrese la localidad!');
        } else if (this.localidad == -1 && this.otraLocalidad == '') {
          return this.mostrarMensaje('Ingrese la localidad!');
        }
        if (this.domicilio == 0) {
          return this.mostrarMensaje('Ingrese el domicilio!');
        }
        if (this.telefono.trim() == "") {
          return this.mostrarMensaje('Ingrese el telefono!');
        }
        if (this.email.trim() == "") {
          return this.mostrarMensaje('Ingrese su email!');
        }
        if (! this.isEmailValid()) {
          return this.mostrarMensaje('El email no es valido!');
        }
        let fecha = this.$moment(`${this.aa}-${this.mm}-${this.dd}`);
        if (! fecha.isValid()) {
          return this.mostrarMensaje('Fecha de nacimiento no valida!');
        }
        if (this.sexo.trim() == "" || this.sexo.trim() == "-") {
          return this.mostrarMensaje('Debe ingresar el sexo!');
        }
        if (this.file == "") {
          return this.mostrarMensaje('Debe adjuntar una foto!');
        }

        this.$store.commit('postulante/setApellido', this.apellido);
        this.$store.commit('postulante/setNombre', this.nombre);
        this.$store.commit('postulante/setFechaNacimiento', fecha.format('YYYY-MM-DD'));
        this.$store.commit('postulante/setSexo', this.sexo);
        this.$store.commit('postulante/setDocumento', this.documento);
        this.$store.commit('postulante/setLocalidad', this.localidad);
        this.$store.commit('postulante/setOtraLocalidad', this.otraLocalidad);
        this.$store.commit('postulante/setProvincia', this.provincia);
        this.$store.commit('postulante/setDomicilio', this.domicilio);
        this.$store.commit('postulante/setConyugue', this.conyugue);
        this.$store.commit('postulante/setTelefono', this.telefono);
        this.$store.commit('postulante/setEmail', this.email);
        this.$store.commit('postulante/setFoto', this.file);
        this.$emit('continuar', 2);
      },
      getProvincias: function() {
        console.log(`http://${RRHH_HOST}/provincia-arg-all`);
        this.$http.get(`http://${RRHH_HOST}/provincia-arg-all`)
        .then(response => response.json())
        .then(json => this.provincias = json, (reason => {
          console.log(reason);
        }))
      },
      getLocalidades: function(pronvinciaId) {
        let url = `http://${RRHH_HOST}/localidades`;
        if(pronvinciaId!==undefined) {
          url += `/${pronvinciaId}`;
        }
        this.$http.get(url)
        .then(response => response.json())
        .then(json => this.localidades = json, (reason => {
          console.log(reason);
        }))
      },
      seleccionarArchivo: function() {
        this.$refs.file.click();
      },
      changeListener: function() {
        this.file = this.$refs.file.files[0];
        this.$store.commit('postulante/setFoto', this.file);
      },
      borrarArchivo: function() {
        this.file = '';
        this.$store.commit('postulante/setFoto', this.file);
      },
      isEmailValid: function() {
        return (this.email == "")? "" : (this.reg.test(this.email)) ? true : false;
      }
    },
    watch: {
      provincia: function(newValue) {
        let id = parseInt(newValue.id, 10)
        this.getLocalidades(id);
      }
    },
    activated() {
      this.$store.commit('pasos/setPasoActivo', 1);
    },
    mounted() {
      //do something after mounting vue instance
      for(let i = 1; i < 32; i++) {
        this.dias.push(i > 0 && i < 10 ? `0${i}` : i);
      }
      let d = this.$moment().startOf('year');
      let h = this.$moment().endOf('year');
      while(d.isSameOrBefore(h)) {
        this.meses.push(d.clone());
        d.add(1, 'month');
      }
      h = this.$moment('1900-01-01', 'YYYY-MM-DD');
      d.subtract(1, 'year');
      while(d.isSameOrAfter(h)) {
        this.anios.push(d.format('YYYY'));
        d.subtract(1, 'year');
      }
      this.getProvincias();
    },
    components: {
      'paso-actual': PasoActual
    }
  }
</script>

<style lang="sass" scoped>
  .fa-asterisk
    color: #C62828
    font-size: 0.698rem
  .cancelar
    padding-left: 15px
    padding-right: 15px
  .c2
      width: 70px !important
      display: inline
  .mes
      width: 110px !important
      display: inline
  .anio
    width: 80px !important
    display: inline

  .form-control
    text-transform: uppercase

  input
    &.file
      width: 0.1px
      height: 0.1px
      opacity: 0
      overflow: hidden
      position: absolute
      z-index: -1
</style>



// WEBPACK FOOTER //
// src/components/Paso1.vue